(function() {
    'use strict';

    /**
     * @memberof app
     * @ngdoc controller
     * @name AnalysisController
     * @description
     * This is form mantenimiento controller
     **/
    angular
        .module('app')
        .controller('AnalysisController', AnalysisController);

    AnalysisController.$inject = ['DataService','$timeout'];

    function AnalysisController(DataService,$timeout) {
        var mc = this;




        console.log("ANALYTICS")
        mc.enfermedades = 'Anaplasma';
        mc.value_test = '+';
        mc.country = 'Colombia';
        mc.city = '-1' ;
        mc.showMap = true ;
        mc.pet_sex = '-1';
        mc.pet_age = '0';
        mc.date = '01/07/2022 - 31/07/2022';

        mc.explorar = function(){
            DataService.setCookie(function(){
                
            })
        }

        mc.datetomaoptions = {
            /*changeCallback: function(){
                $timeout(function(){
                    vm.init();
                });
            },*/
            singleDatePicker: false,
            //maxDate : moment(),
            opens:'left',
            drops:'up',
            alwaysShowCalendars: true,
            showCustomRangeLabel: false,
            locale: {
                applyLabel: "Aplicar",
                cancelLabel: 'Cancelar',
                clearLabel: 'Limpiar',
                separator: ' - ',
                format: "DD-MM-YYYY",
            },
            ranges: {
                'Hoy': [moment(), moment()],
                'Ayer': [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
                'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
                'Mes actual': [moment().startOf('month'), moment().endOf('month')],
                'Mes anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            eventHandlers: {
                'apply.daterangepicker': function(event, picker) { $timeout(function(){
                    mc.init(0);
                }); },
                'cancel.daterangepicker': function(event, picker) { $timeout(function(){
                    mc.init(0);
                }); }
            }/*,
            cancelOnOutsideClick:true*/
        };
                    
        mc.heatmapdata = [];


        mc.ratios = {};
        mc.pos = 0;
        mc.ratio = 0;
        mc.ratiosArr = [] ;
        mc.totales = 0;
        mc.totalesPos = 0;    
        mc.init=function()
        {
            mc.showMap = false;
            mc.heatmapdata =  [] ;
            mc.totales = 0;
            mc.totalesPos = 0;
            mc.ratios = {};
            mc.ratiosCP = {};
            mc.ratiosArr = [] ;
            mc.ratiosArrCp = [] ;
            DataService.getData(mc.enfermedades,mc.value_test,mc.country,mc.pet_sex,mc.pet_age,mc.date,mc.city).then(function(data)
            {
                console.log(data);
                var geo = {} ;
                for (var i = 0; i < data.analysis.length; i++) 
                {
                    //data.analysis[i].geo_location
                    geo = JSON.parse(data.analysis[i].geo_location);
                    if(mc.ratios[data.analysis[i].city] ==undefined ){
                       mc.ratios[data.analysis[i].city] = {ratio:0,pos:0,total:0,lat:geo.latitude,lng:geo.longitude};
                    }

                    if(mc.ratiosCP[data.analysis[i].postal_code] == undefined ){
                       mc.ratiosCP[data.analysis[i].postal_code] = {ratio:0,pos:0,total:0,lat:geo.latitude,lng:geo.longitude};
                    }

                    if(data.analysis[i].value_test == '+' || data.analysis[i].text_test=='StrongPositive')
                    {
                        //mc.heatmapdata.push( {location: new google.maps.LatLng(geo.lat, geo.lng), weight: 1} );
                        mc.ratios[data.analysis[i].city].pos++ ;
                        mc.ratiosCP[data.analysis[i].postal_code].pos++ ;
                        mc.totalesPos++ ;
                    }
                    else
                    {
                        //mc.heatmapdata.push( {location: new google.maps.LatLng(geo.lat, geo.lng), weight: 0} )

                    }

                    mc.totales++;
                    mc.ratios[data.analysis[i].city].total++ ;
                    mc.ratiosCP[data.analysis[i].postal_code].total++ ;

                    if(mc.ratios[data.analysis[i].city].pos){
                        mc.ratios[data.analysis[i].city].ratio = mc.ratios[data.analysis[i].city].pos/mc.ratios[data.analysis[i].city].total;
                        mc.ratiosCP[data.analysis[i].postal_code].ratio = mc.ratiosCP[data.analysis[i].postal_code].pos/mc.ratiosCP[data.analysis[i].postal_code].total;
                    }


                }
                console.log(mc.ratios);

                var arr = [];
                var arrcp = [];

                angular.forEach(mc.ratios, function (value, key) {
                    arr.push({'key':key,'value':value});
                    if(value.total>10 && value.ratio*100 >= 5){
                        //mc.heatmapdata.push( {location: new google.maps.LatLng(value.lat, value.lng), weight: parseInt(value.ratio*100) } )
                    }else{
                        //mc.heatmapdata.push( {location: new google.maps.LatLng(value.lat, value.lng), weight: 0 } )
                    }
                });  

                angular.forEach(mc.ratiosCP, function (value, key) {

                    arrcp.push({'key':key,'value':value});
                    if(/*value.total>25 && */value.ratio*100 >= 5){
                        if(value.ratio>0){
                            mc.heatmapdata.push( {location: new google.maps.LatLng(value.lat, value.lng), lat:value.lat, lng:value.lng, weight: parseInt(value.ratio*1000) } )
                        }
                    }else{
                        if(value.ratio>0){
                            mc.heatmapdata.push( {location: new google.maps.LatLng(value.lat, value.lng), lat:value.lat, lng:value.lng, weight: 3 } );
                        }
                    }

                    /*var myLatLng = new google.maps.LatLng(value.lat, value.lng);

                      const map = new google.maps.Map(
                        map,
                        {
                          zoom: 4,
                          center: myLatLng,
                        }
                      );

                      new google.maps.Marker({
                        position: myLatLng,
                        map,
                        title: "Hello World!",
                      });*/


                });  
                mc.ratiosArrCp = arrcp;
                mc.ratiosArr =  arr;
                
                $timeout(function(){

                    mc.showMap = true;
                })
            });
        }

    }


})();
